import produce from 'immer'
import { assign, isNil, size } from 'lodash'

import { transformIngredientKeywordToInitialState } from '../../../common/graphql/transformers'

import {
  CHECK_SUPPORTING_KEYWORD_NODES_FOR_TYPE,
  FETCH_INGREDIENT_KEYWORDS,
} from '../action-types'

const ingredientSupportingKeywordsReducer = (state, action) => {
  switch (action.type) {
    case FETCH_INGREDIENT_KEYWORDS.START:
      return produce(state, nextState => {
        assign(nextState.keywords, {
          supporting: {
            isLoading: true,
            error: undefined,
            data: [],
            checkedKeywordKeys: {
              synonyms: [],
              varieties: [],
              discarded: [],
              uncategorized: [],
            },
          },
        })

        return nextState
      })

    case FETCH_INGREDIENT_KEYWORDS.COMPLETE:
      return produce(state, nextState => {
        const keywords = action.payload.data.ingredientKeywords

        const { synonyms, varieties, discarded, uncategorized } =
          transformIngredientKeywordToInitialState(keywords)

        assign(nextState.keywords, {
          supporting: {
            isLoading: false,
            error: undefined,
            data: { synonyms, varieties, discarded, uncategorized },
            checkedKeywordKeys: {
              synonyms: [],
              varieties: [],
              discarded: [],
              uncategorized: [],
            },
          },
        })

        return nextState
      })

    case FETCH_INGREDIENT_KEYWORDS.FAIL:
      return produce(state, nextState => {
        assign(nextState.keywords, {
          supporting: {
            isLoading: false,
            error: action.error.message,
            data: [],
            checkedKeywordKeys: {
              synonyms: [],
              varieties: [],
              discarded: [],
              uncategorized: [],
            },
          },
        })

        return nextState
      })

    case CHECK_SUPPORTING_KEYWORD_NODES_FOR_TYPE:
      return produce(state, nextState => {
        const { type, checkedKeys } = action.payload
        const keyToCheck = checkedKeys[size(checkedKeys) - 1]

        assign(nextState.keywords, {
          supporting: {
            ...nextState.keywords.supporting,
            checkedKeywordKeys: {
              synonyms: [],
              varieties: [],
              uncategorized: [],
              discarded: [],
              [type]: isNil(keyToCheck) ? [] : [keyToCheck],
            },
          },
        })

        return nextState
      })

    default:
      return state
  }
}

export default ingredientSupportingKeywordsReducer
